export default __webpack_public_path__ + "static/media/about-team-19.e702d8e8.png";